"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.prescriptionTypesMap = void 0;
/** Esta variable mapea los tipos de prescripcion con su nombre en español */
exports.prescriptionTypesMap = {
    "order": "orden",
    "prescriptions": "receta"
};
